import React, { FC, useEffect, useState } from 'react';
import { Button, Modal, Spin } from 'antd';
import { useAppSelector } from 'common/hooks';
import { TimeEditorItem } from 'entities/Modal/components';
import { timerValueToMilliseconds } from 'entities/Timer/Timer.helper';

interface IComponentProps {
  hours: number;
  minutes: number;
  seconds: number;
  onSave: (milliseconds: number) => void;
  onCancel: () => void;
}

export const TimeEditorModal: FC<IComponentProps> = ({ hours, minutes, seconds, onSave, onCancel }) => {
  const { open, timerLoading } = useAppSelector((state) => ({
    open: state.modal.timeEditorModalParams.open,
    timerLoading: state.timer.loading,
  }));
  const [hoursValue, setHoursValue] = useState<number>(0);
  const [minutesValue, setMinutesValue] = useState<number>(0);
  const [secondsValue, setSecondsValue] = useState<number>(0);

  const handleSaveClick = () => {
    const milliseconds = timerValueToMilliseconds(hoursValue, minutesValue, secondsValue);
    onSave(milliseconds);
  };

  useEffect(() => {
    if (open) {
      setHoursValue(hours);
      setMinutesValue(minutes);
      setSecondsValue(seconds);
    }
  }, [open]);

  return (
    <Modal className="modal time-editor" title="Edit spent time" open={open} footer={false} onCancel={onCancel} width={600}>
      <Spin spinning={timerLoading}>
        <div className="d-flex align-center justify-center modal__body" style={{ gap: 10 }}>
          <TimeEditorItem value={hoursValue} setValue={setHoursValue} isHours />

          <span className="fs-lg">:</span>

          <TimeEditorItem value={minutesValue} setValue={setMinutesValue} />

          <span className="fs-lg">:</span>

          <TimeEditorItem value={secondsValue} setValue={setSecondsValue} />
        </div>

        <div className="d-flex align-center time-editor__footer" style={{ gap: 18 }}>
          <Button className="blue" onClick={handleSaveClick}>
            Save
          </Button>

          <Button className="default" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </Spin>
    </Modal>
  );
};
